<template>
    <csp-form-group-checkbox-group
        :buttons="true"
        :form="form"
        :options="options"
        :property="property"
        v-bind="$attrs"
        @change="emitChange"/>
</template>

<script>
    export default {
        props: {
            form: {
                type: Object,
                required: true,
            },
            options: {
                type: Array,
                default: null,
            },
            property: {
                type: String,
                default: null,
            },
        },
        emits: ['change'],
        methods: {
            emitChange(value) {
                this.$emit('change', value);
            },
        },
    }
</script>
